// import "./Loader.css";

// export default function Loader() {
//     return (
//         <div className="loader-overlay">

//             <div className="loader-content">

//                 <div className="loader-spinner">
//                     <div className="loader-spinner-inner"></div>
//                 </div>

//                 <h3>Confirming your check-in...</h3>

//                 <p>
//                     Please hold on for a moment while we
//                     <br />
//                     complete the process
//                 </p>

//             </div>

//         </div>
//     );
// }


import "./Loader.css";
import { useLoaderStore } from "../../store/loaderStore";

export default function Loader() {
    const { loading, loaderType } = useLoaderStore();

    if (!loading) {
        return null;
    }

    if (loaderType === "master") {
        return (
            <div className="loader-overlay">
                <div className="loader-content master-loader-content">

                    <div className="loader-spinner">
                        <div className="loader-spinner-inner"></div>
                    </div>

                    <h3>Loading...</h3>

                    <p>
                        Please wait while we
                        <br />
                        complete the process
                    </p>

                </div>
            </div>
        );
    }

    return (
        <div className="loader-overlay">
            <div className="loader-content">

                <div className="loader-spinner">
                    <div className="loader-spinner-inner"></div>
                </div>

                <h3>Confirming your check-in...</h3>

                <p>
                    Please hold on for a moment while we
                    <br />
                    complete the process
                </p>

            </div>
        </div>
    );
}